/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import sortIcon from '../../../icons/inspection-icons/sort.svg';
import sortActiveIcon from '../../../icons/inspection-icons/sort-active.svg';
import styles from '../../../styles/general.module.scss';

const Table = ({ data, url, columnsArray,
   getColData, sortField, handleSort }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (data?.length) {
      const formsList = data.map(form => ({
        ...form,
        created: form.created_by?.fullname,
        weather: form?.weather_conditions?.title
      }));
      setTableData(formsList);
    } else {
      setTableData([]);
    }
  }, [data]);

return (
  <div className={styles.responsiveTableWrapper}>
    <table className={styles.table}>
      <thead>
        <tr>
          {columnsArray?.map((item) => {
            if (item?.selected) {
              return (
                <th key={item.id}>
                  <FormattedMessage id={item?.id} defaultMessage={item?.title} />
                  <img
                    src={sortField === item.dataKey ? sortActiveIcon : sortIcon}
                    alt=""
                    onClick={() => handleSort(item)}
                    onKeyPress={() => handleSort(item)}
                  />
                </th>
              );
            }
            return null;
          })}
          <th />
        </tr>
      </thead>
      <tbody>
        {tableData && tableData.map(fd => (
          <tr key={fd.id}>
            {columnsArray?.map((item) => {
              if (item?.selected) {
                return (
                  <td key={item.id}>{getColData(fd, item)}</td>
                );
              }
              return null;
            })}
            <td className="text-break">
              <Link to={`${url}/${fd.key}/${fd?.status === 'draft' ? 'edit_form' : 'detail'}`}>
                <FormattedMessage
                  id="inspections.list.table.view"
                  defaultMessage="View"
                />
              </Link>
            </td>
          </tr>
        ))}
        {tableData.length === 0 && (
          <td colSpan={6}>
            <FormattedMessage
              id="forms.list.table.no_results"
              defaultMessage="There are no forms on the selected range"
            />
          </td>
        )}
      </tbody>
    </table>
  </div>
);
};

Table.propTypes = {
  data: PropTypes.shape([]).isRequired
};

const mapStateToProps = state => ({
  profileRoles: state?.auth?.profile?.roles
});


export default connect(
  mapStateToProps,
  {}
)(Table);
